import { colors } from "colors"
import { Dimensions, StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  canvasStyle: {
    display: "none",
    height: "auto",
  },
  capturedImage: {
    height: "80%",
    marginVertical: "1vw",
    resizeMode: "contain",
    width: "80%",
  },
  container: { flex: 1, height: "100%", padding: 10 },
  dropdown: {
    backgroundColor: colors.inputFieldBackground,
    borderColor: colors.inputFieldBorder,
    borderRadius: 999,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 10,
    minHeight: 50,
    paddingRight: 10,
    marginBottom: "5rem",
  },
  errorTextField: {
    borderColor: colors.error,
  },
  flex: { flex: 1 },
  headerContainer: { borderBottomLeftRadius: 10, borderBottomRightRadius: 10 },
  idTypeContainer: { flex: 0.5 },
  imageStyle: {
    display: "flex",
    height: "100%",
    justifySelf: "center",
    maxWidth: 600,
    width: "100%",
  },
  inputContainer: { alignSelf: "center", marginTop: 20 },
  inputStyle: {
    height: 50,
    paddingLeft: 10,
    paddingVertical: 10,
    width: "100%",
  },
  mb40: { marginBottom: 40 },
  mediaContainer: {
    alignItems: "center",
    display: "flex",
    height: "50%",
    justifyContent: "center",
    maxHeight: 400,
    width: "100%",
  },
  modalButton: {
    color: colors.white,
  },
  modalContainer: {
    alignItems: "center",
    display: "flex",
    height: Dimensions.get("window").height,
    margin: 0,
    padding: 0,
    width: Dimensions.get("window").width,
  },
  modalContentButton: {
    borderRadius: 10,
    borderWidth: 3,
    padding: 10,
    textAlign: "center",
    width: "100%",
  },
  modalContentContainer: {
    alignSelf: "center",
    backgroundColor: colors.white,
    borderRadius: 20,
    height: "80%",
    maxWidth: 800,
    padding: 15,
  },
  pt5: {
    paddingTop: "5%",
  },
  title: {
    fontFamily: typography.primary.normal,
    fontSize: 12,
    marginBottom: 6,
    paddingLeft: 4,
  },
  titleContainer: {
    backgroundColor: colors.white,
    left: 20,
    opacity: 1,
    position: "absolute",
    top: 2,
    zIndex: 9999,
  },
  titleText: {
    fontFamily: typography.primary.normal,
    fontSize: 23,
    textAlign: "center",
  },
  videoContainer: {
    display: "flex",
    height: "50%",
    justifyContent: "center",
    maxHeight: 400,
    maxWidth: "100%",
    width: "100%",
  },
  videoStyle: {
    display: "flex",
    height: "auto",
    justifySelf: "center",
    maxWidth: 600,
    width: "100%",
  },
})
